'use client';

import { MenuRoot, type MenuProps, type MenuBaseProps } from './Menu';
import {
  MenuDivider,
  type MenuDividerProps,
  type MenuDividerBaseProps,
  menuDividerClasses,
} from './MenuDivider';
import {
  MenuHeader,
  type MenuHeaderProps,
  type MenuHeaderBaseProps,
  menuHeaderClasses,
} from './MenuHeader';
import {
  MenuItem,
  type MenuItemProps,
  type MenuItemBaseProps,
  menuItemClasses,
} from './MenuItem';
import {
  MenuItemAffix,
  type MenuItemAffixProps,
  type MenuItemAffixBaseProps,
  menuItemAffixClasses,
} from './MenuItemAffix';
import {
  MenuItemIndicator,
  type MenuItemIndicatorProps,
  type MenuItemIndicatorBaseProps,
  menuItemIndicatorClasses,
} from './MenuItemIndicator';
import {
  MenuItemText,
  type MenuItemTextProps,
  type MenuItemTextBaseProps,
  menuItemTextClasses,
} from './MenuItemText';
import {
  MenuMultiSelectItem,
  type MenuMultiSelectItemProps,
  type MenuMultiSelectItemBaseProps,
  menuMultiSelectItemClasses,
} from './MenuMultiSelectItem';
import {
  MenuPopup,
  type MenuPopupProps,
  type MenuPopupBaseProps,
  menuPopupClasses,
} from './MenuPopup';
import {
  MenuSingleSelectGroup,
  type MenuSingleSelectGroupProps,
  type MenuSingleSelectGroupBaseProps,
} from './MenuSingleSelectGroup';
import {
  MenuSingleSelectItem,
  type MenuSingleSelectItemProps,
  type MenuSingleSelectItemBaseProps,
  menuSingleSelectItemClasses,
} from './MenuSingleSelectItem';
import {
  MenuTrigger,
  type MenuTriggerProps,
  type MenuTriggerBaseProps,
} from './MenuTrigger';

const Menu = Object.assign(MenuRoot, {
  Trigger: MenuTrigger,
  Popup: MenuPopup,
  Item: MenuItem,
  MultiSelectItem: MenuMultiSelectItem,
  SingleSelectGroup: MenuSingleSelectGroup,
  SingleSelectItem: MenuSingleSelectItem,
  ItemIndicator: MenuItemIndicator,
  ItemAffix: MenuItemAffix,
  ItemText: MenuItemText,
  Divider: MenuDivider,
  Header: MenuHeader,
});

export {
  Menu,
  type MenuProps,
  type MenuBaseProps,
  type MenuTriggerProps,
  type MenuTriggerBaseProps,
  type MenuPopupProps,
  type MenuPopupBaseProps,
  menuPopupClasses,
  type MenuItemProps,
  type MenuItemBaseProps,
  menuItemClasses,
  type MenuMultiSelectItemProps,
  type MenuMultiSelectItemBaseProps,
  menuMultiSelectItemClasses,
  type MenuSingleSelectGroupProps,
  type MenuSingleSelectGroupBaseProps,
  type MenuSingleSelectItemProps,
  type MenuSingleSelectItemBaseProps,
  menuSingleSelectItemClasses,
  type MenuItemIndicatorProps,
  type MenuItemIndicatorBaseProps,
  menuItemIndicatorClasses,
  type MenuItemAffixProps,
  type MenuItemAffixBaseProps,
  menuItemAffixClasses,
  type MenuItemTextProps,
  type MenuItemTextBaseProps,
  menuItemTextClasses,
  type MenuDividerProps,
  type MenuDividerBaseProps,
  menuDividerClasses,
  type MenuHeaderProps,
  type MenuHeaderBaseProps,
  menuHeaderClasses,
};
